module.exports = "/packs/media/images/icons/default_savings-9e99f8e4adb06ef4e25caf3db7c1fd6b.png";